import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const deleteProjectApi = async (projectId: string): Promise<void> => {
  const token = await getToken();
  if (!token) throw new Error("Authorization token is required");

  await axios.delete(`${API_BASE_URL}/projects/${projectId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  /*
  notifications.show({
    title: "Project deleted",
    message: "The project has been successfully deleted.",
    color: "success",
  });
 */
};
